module.exports = __webpack_public_path__ + "static/media/3.da74ad95.jpg";